import React, { FC } from "react";
import PageTemplate from "../../../components/Layout/Common/PageTemplate";
import List from "../../../components/SystemSettings/List";

const SystemSettingsList: FC = () => {
  return (
    <PageTemplate title={"Sustem Settings"}>
      <List />
    </PageTemplate>
  );
};

export default SystemSettingsList;
